var results=new Array();
var gCurrentPlay=0;

function replaceSplChars(content){
    var myRegExp=new RegExp("&#153;|&#174;|&#8482;","gi");
    content=content.replace(myRegExp,"");
    return content;
}

function doOnGalleryPlay(entryId,divNum)
{
    myPlayer.catalog.getVideo(entryId, function (error, video){
    myPlayer.catalog.load(video);
    myPlayer.play();})
    if (divNum >= 0){
        ResetScrollText();
        document.getElementById("imgGal_"+gCurrentPlay).src = "/graphics/video/gallery-play.png";
        document.getElementById("imgGal_"+divNum).src = "/graphics/video/gallery-playing.png";
        var imgFrame = document.getElementById("imgFrame_"+gCurrentPlay);
        imgFrame.height = "121";
        imgFrame.width = "164";
        imgFrame.style.border = "";
        imgFrame.style.borderWidth = "";
        imgFrame.style.borderColor = "";
        var imgFrameDiv = document.getElementById("imgFrame_"+divNum);
        imgFrameDiv.height = "117";
        imgFrameDiv.width = "160";
        imgFrameDiv.style.border = "solid";
        imgFrameDiv.style.borderWidth = "2px";
        imgFrameDiv.style.borderColor = "#ff0303";
        document.getElementById("entryTitle").innerHTML = GetEllipsedByHeightText (document.getElementById("entryTitle"), results[entryId].name, "65");
        document.getElementById("entryDesc").innerHTML = '<div class="galleryDesc">' + results[entryId].description + '</div>';
        document.getElementById("entryPosted").innerHTML = results[entryId].posted;
        document.getElementById("entryDuration").innerHTML = results[entryId].duration;
        document.getElementById("entryViews").innerHTML = results[entryId].views;
        document.getElementById("entryLink").href = results[entryId].linkURL;
        document.getElementById("entryLink").innerHTML = results[entryId].linkText;
        gCurrentPlay = divNum;
    }
}

